var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-grey-lighter h-full font-sans",attrs:{"id":"app"}},[_c('transition',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }